import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GzDashboardAppDataProviderFactory } from '../factory/GzDashboardAppDataProviderFactory';
import { GzDashboardsAppNirvanaDataProvider } from '../dataProvider/GzDashboardsAppNirvanaDataProvider';
import { InitGenericDashboardResponse } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export class GzDashboardAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GzDashboardAppDataProviderFactory;
  public dataProvider: GzDashboardsAppNirvanaDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GzDashboardAppDataProviderFactory(),
    });
  }

  async computeUserConfigForDashboard(request: any): Promise<InitGenericDashboardResponse> {
    return await this.dataProvider.computeUserConfigForDashboard(request);
  }
}
